<!--输入桩号-->
<template>
  <div class="container ">
    <div class="container-flex banner-details" v-if="bannerInfo">
      <div class="home-banner-title">{{ bannerInfo.bannerDetailTitle }}</div>
      <div
        class="home-banner-content"
        v-html="bannerInfo.bannerDetailContent"
      ></div>
    </div>
  </div>
</template>

<script>
import common from "@/common/old/public/common";
export default {
  name: "home-banner-details",
  data() {
    return {
      bannerInfo: null,
    };
  },
  methods: {},
  mounted() {
    let data = common.get("home-banner-details");
    if (data) {
      this.bannerInfo = data;
    }
  },
};
</script>

<style lang="less" scoped>
.banner-details {
  padding: 0.24rem;

  .home-banner-title {
    font-size: 0.32rem;
    line-height: 0.44rem;
  }
  .home-banner-content {
    margin-top: 0.32rem;
  }
}
</style>
